import { LayoutGrid, Wrench, CreditCard, Truck, Building2, ShoppingBag, Users, BarChart3, MessageSquare, Briefcase, FileText } from "lucide-react";
import { getLocalizedPath } from "@/i18n/routes";
import { Lang } from "@/i18n/routes";

export const getSolutionsMenu = (lang: Lang) => [
  { 
    to: getLocalizedPath("erpMain", lang), 
    slugBase: "erpMain", 
    key: "erp",
    label: lang === 'es' ? "ERP para Patinetes" : (lang === 'ar' ? "نظام ERP للمنقل" : "ERP for Scooters"), 
    icon: LayoutGrid,
    category: "integral"
  },
  { 
    to: "/soluciones/erp-tienda-taller-patinetes-electricos", 
    slugBase: "saasLanding", 
    key: "saas-landing",
    label: lang === 'es' ? "Software Especializado" : "Specialized Software", 
    icon: LayoutGrid,
    category: "integral"
  },
  { 
    to: getLocalizedPath("moduleLanding", lang, lang === 'es' ? "crm-para-patinetes-electricos" : "crm"), 

    slugBase: "moduleLanding", 
    key: "crm",
    slug: "crm-para-patinetes-electricos", 
    label: lang === 'es' ? "CRM Patinetes" : (lang === 'ar' ? "إدارة علاقات العملاء" : "Scooter CRM"), 
    icon: Users,
    category: "ventas"
  },
  { 
    to: getLocalizedPath("moduleLanding", lang, lang === 'es' ? "gestion-taller-patinetes-electricos" : "workshop"), 
    slugBase: "moduleLanding", 
    key: "workshop",
    slug: "gestion-taller-patinetes-electricos", 
    label: lang === 'es' ? "Gestión de Taller" : (lang === 'ar' ? "إدارة الورشة" : "Workshop Management"), 
    icon: Wrench,
    category: "operaciones"
  },
  { 
    to: getLocalizedPath("moduleLanding", lang, lang === 'es' ? "tpv-tienda-patinetes-electricos" : "ecommerce"), 
    slugBase: "moduleLanding", 
    key: "pos",
    slug: "tpv-tienda-patinetes-electricos", 
    label: lang === 'es' ? "eCommerce & Ventas" : (lang === 'ar' ? "التجارة الإلكترونية" : "eCommerce & Sales"), 
    icon: CreditCard,
    category: "ventas"
  },
  { 
    to: getLocalizedPath("moduleLanding", lang, "marketing-campanas-ads-patinetes"), 
    slugBase: "moduleLanding", 
    key: "marketing",
    slug: "marketing-campanas-ads-patinetes", 
    label: lang === 'es' ? "Marketing y Ads" : (lang === 'ar' ? "التسويق والإعلانات" : "Marketing & Ads"), 
    icon: ShoppingBag,
    category: "ventas"
  },
  { 
    to: getLocalizedPath("moduleLanding", lang, lang === 'es' ? "software-alquiler-patinetes-electricos" : "rental"), 
    slugBase: "moduleLanding", 
    key: "rentals",
    slug: "software-alquiler-patinetes-electricos", 
    label: lang === 'es' ? "Alquiler de Flotas" : (lang === 'ar' ? "تأجير الأساطيل" : "Fleet Rental"), 
    icon: Truck,
    category: "operaciones"
  },
  { 
    to: getLocalizedPath("useCaseLanding", lang, "talleres-reparacion"), 
    slugBase: "useCaseLanding", 
    slug: "talleres-reparacion", 
    label: lang === 'es' ? "Para Talleres" : (lang === 'ar' ? "للورش" : "For Workshops"), 
    icon: Building2,
    category: "sectorial"
  },
  { 
    to: getLocalizedPath("useCaseLanding", lang, "tiendas-patinetes"), 
    slugBase: "useCaseLanding", 
    slug: "tiendas-patinetes", 
    label: lang === 'es' ? "Para Tiendas" : (lang === 'ar' ? "للمتاجر" : "For Shops"), 
    icon: ShoppingBag,
    category: "ventas"
  },
  { 
    to: getLocalizedPath("useCaseLanding", lang, "alquiler-vehiculos"), 
    slugBase: "useCaseLanding", 
    slug: "alquiler-vehiculos", 
    label: lang === 'es' ? "Para Alquiler" : (lang === 'ar' ? "للتأجير" : "For Rental"), 
    icon: Users,
    category: "sectorial"
  },
];